// const API_URL = "http://localhost:3005"
const API_URL = "https://server2.ardunifertmaroc.com"

export default API_URL
